import { styled } from '@mui/material/styles';
import FuseMessage from '@fuse/core/FuseMessage';
import AppContext from 'app/AppContext';
import { lazy, memo, ReactNode, Suspense, useContext } from 'react';
import { useRoutes } from 'react-router-dom';
import { selectFuseCurrentLayoutConfig } from '@fuse/core/FuseSettings/fuseSettingsSlice';
import { Layout1ConfigDefaultsType } from 'app/theme-layouts/layout1/Layout1Config';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { useAppSelector } from 'app/store/hooks';
import RightSideLayout1 from './components/RightSideLayout1';
import { usePopupStore } from 'app/store/popupStore';
import AlertComponent from 'app/shared-components/alert/AlertComponent';

const FuseDialog = lazy(() => import('@fuse/core/FuseDialog/FuseDialog'));

const Root = styled('div')(({ config }: { config: Layout1ConfigDefaultsType }) => ({
	...(config.mode === 'boxed' && {
		clipPath: 'inset(0)',
		maxWidth: `${config.containerWidth}px`,
		margin: '0 auto',
		boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
	}),
	...(config.mode === 'container' && {
		'& .container': {
			maxWidth: `${config.containerWidth}px`,
			width: '100%',
			margin: '0 auto'
		}
	})
}));

type Layout1Props = {
	children?: ReactNode;
};

/**
 * The layout 1.
 */
function Layout1(props: Layout1Props) {
	const { children } = props;
	const config = useAppSelector(selectFuseCurrentLayoutConfig) as Layout1ConfigDefaultsType;
	const appContext = useContext(AppContext);
	const { routes } = appContext;

	return (
		<Root
			id="fuse-layout"
			config={config}
			className="flex w-full overflow-x-hidden overflow-y-auto lg:overflow-y-hidden bg-transparent transform scale-190"
		>
			<AlertComponent />
			<main
				id="fuse-main"
				className="relative z-10 flex min-h-0 min-w-0 flex-auto flex-col overflow-y-auto lg:overflow-y-hidden">
				<div className="relative z-10 flex min-h-0 flex-auto flex-col bg-[#faf9f8]">
					<FuseSuspense>{useRoutes(routes)}</FuseSuspense>

					{/* <Suspense>
					</Suspense> */}
					{children}
				</div>

			</main>
			{config.rightSidePanel.display && <RightSideLayout1 />}
			<FuseMessage />
		</Root>
	);
}

export default memo(Layout1);